import React from "react";
import ContainerProjetos from "./ContainerProjetos";
import './style.css'

export default function Projetos() {
    return (
        <section className='Projetos' id="Projetos">
            <h2 className='titulo-section'>Projetos</h2>
            <div className='conteudo-projetos'>
                <ContainerProjetos link={'/Project/Startemy'} title={'Startemy'} bgImage={'/assets/Startemy.webp'} />            
                <ContainerProjetos link={'/Project/FunnyJoke'} title={'Joke'} bgImage={'/assets/joke/Wallpaper.webp'} />            
            </div>
        </section>
    )
}